import styled from 'styled-components';

export const InteractiveFilterMiniaturesContainer = styled.div`
  margin-top: 2.25rem;
  display: flex;
`;
